/*
Component Name: AddNotes component
Usage: Use for adding notes for a cooking day
Includes : Services for custom calander
Default screen: Dashboard
*/

import React, { Component } from 'react'

class NotesPopup extends Component {
  constructor(props){
    super(props)
    this.state = {
      ...props,
      input:{ },
      error: false,
      showDelete: false,
      zIndex: '1000000'
    }
  }

  componentWillReceiveProps(props) {
    this.setState({ ...props })
    // console.log(props)
  }

  onSave() {
    const { content, input, notesDate, mode, notes, cookIndex } = this.state
    
    input.content = content !== undefined ? content : notes ? notes.content : ''
    input.date = notesDate
    if(mode === 'edit' && notes ) {
      input.id=notes.id
    }
    if(input.content !== '') {
      this.setState({ zIndex: '1000'})
      this.props.onSave(input,notesDate, mode, cookIndex)
    }
    else {
      this.setState({ error: true})
    }
  }

  showDeleteNotes() {
    const { showDelete } = this.state
    this.setState({ showDelete: !showDelete})  
  }

  deleteNotes() {
    const { notes, cookIndex } = this.state
    this.setState({ zIndex: '1000'})
    this.props.onDelete(notes.id, cookIndex)

  }

  
  updateValue(event) {
    this.setState({ content: event.target.value, error: false})
  }

  // keyEvent(event) {
  //   // console.log(event.keyCode)
  //   // if(event.keyCode === 13)
  //   //   this.onSave()
  // }




  render(){
    const { notes, mode, error, showDelete, notesError } = this.state
    // console.log(notesError,'jkjk')
    // alert(notes)

    const data = notes ? notes.content : ''
    const deletePopClass = showDelete ? 'edit-popup delnts-popup' : 'edit-popup'
    let {zIndex} = this.state
    const headingText = mode === 'add' ? 'Add Notes' : 'Edit Notes' 
    zIndex = notesError ? '100000' : zIndex
    return(
      <div className={deletePopClass}>
        <div className="modal fade in" style={{zIndex}}>
          <div className="modal-content">
            <h2> 
              {headingText} 
              <img src="/images/clos.svg" alt="" className="cross" onClick={()=>this.props.closePopup()}/>
            </h2>
            <div className="edit-content">
              {!showDelete ? 
                <div className="add-feedback">
                  <div className="fdbck-txtarea">
                    <textarea 
                      className="textarea" 
                      placeholder= "Enter your notes here" 
                      onChange={(event)=>this.updateValue(event)}
                      // onKeyDown={(event)=>this.keyEvent(event)}
                      defaultValue={data}
                      // eslint-disable-next-line
                      autoFocus
                    />
                    { error ?
                      <span className="notes error-msg">Notes can't be empty</span> : null
                    }
                    { notesError ?
                      <span className="notes error-msg">Network error, Please try again later</span> : null
                    }
                  </div>
                  <div className="nxt-stp">
                    {mode === 'edit' && 
                      <button type="button" className="skip-feedback" onClick={()=>this.showDeleteNotes()}> 
                        <img src="/images/del.svg" alt="" /><span>Delete</span>
                      </button>
                    }
                    <button type="button" className="btn btn-success save-notes" onClick={()=>this.onSave()}> 
                      Save
                    </button>
                  </div>
                </div>
                
                :
                <div className="add-feedback">
                  <h4> Are you sure want to delete this note?</h4>
                  <div className="edit-text">
                    <div className="nw-rcp">
                      <button onClick={()=>this.deleteNotes()}>Yes, Delete It!</button>
                    </div>
                    <div className="rst-pln">
                      <button className="cancl" onClick={()=>this.props.closePopup()}> Cancel</button>
                    </div>
                  </div>
                </div>
              }
              {/* </div> */}

            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default NotesPopup


// WEBPACK FOOTER //
// ./src/components/dashboard/NotesPopup.js